import sortBy from 'lodash/sortBy';

import {
  ACTIVITIES_COMPONENT_TYPE_COLUMNS,
  ACTIVITIES_COMPONENT_TYPE_ACTIVITY,
} from 'global/constants';
import { SectionOrSubSection } from '../activity-builder.constants';
import ColumnsPreview from './columns/columns-preview';
import { ComponentColumns } from './component.constants';
import { ComponentViewWrapper } from './components-view-wrapper.style';
import ComponentPreviewComponents from './component-preview-components';
import ComponentsViewWrapper from './components-view-wrapper';
import { getStyleProperties } from './components.utils';
import {
  getAppliedColour,
  isBackgroundApplied,
  isBorderApplied,
} from './shared/component-settings-borders.utils';

type Props = {
  section: SectionOrSubSection;
  contentId: number;
};

const ComponentsPreview = ({ section, contentId }: Props) => {
  const components = section?.components;
  const sortedComponents = sortBy(components, 'sort');

  if (!sortedComponents) return null;

  return (
    <div>
      {sortedComponents.map(component => {
        return component.type !== ACTIVITIES_COMPONENT_TYPE_ACTIVITY ? (
          <ComponentViewWrapper
            key={component.id}
            $marginBottom={
              component.type === ACTIVITIES_COMPONENT_TYPE_COLUMNS
                ? 0
                : undefined
            }
          >
            {component.type === ACTIVITIES_COMPONENT_TYPE_COLUMNS ? (
              <ColumnsPreview
                {...(component as ComponentColumns)}
                contentId={contentId}
              />
            ) : (
              <ComponentsViewWrapper
                key={component.id}
                type={component.type}
                colours={getAppliedColour(getStyleProperties(component))}
                showBorder={isBorderApplied(getStyleProperties(component))}
                showBackground={isBackgroundApplied(
                  getStyleProperties(component)
                )}
              >
                <ComponentPreviewComponents component={component} />
              </ComponentsViewWrapper>
            )}
          </ComponentViewWrapper>
        ) : null;
      })}
    </div>
  );
};

export default ComponentsPreview;
